import UAParser from 'ua-parser-js'

import { getEnvironmentAtRunTime } from '@cash-web/shared-util-environment'

export const ANDROID_STORE =
  'https://play.google.com/store/apps/details?id=com.squareup.cash&referrer=utm_medium%3Dweb%26utm_source%3Dcash-web'
export const APPLE_STORE = 'https://itunes.apple.com/us/app/square-cash/id711923939?pt=302818&mt=8&ct=cash-web'

// exported for testing
export const APP_DOWNLOAD_WITH_DEEP_LINK_PRODUCTION = 'https://click.cash.app/ui6m/b6ca51f0'
const APP_DOWNLOAD_WITH_DEEP_LINK_STAGING = 'https://click.cash.app/LhNg/35a5f3f8'

export const getAppStoreUrl = () => {
  const uaParser = new UAParser()
  const os = uaParser.getOS()
  return os.name === 'Android' ? ANDROID_STORE : APPLE_STORE
}

export const getAppDownloadWithDeepLinkURL = (customUrl?: string) => {
  const env = getEnvironmentAtRunTime()
  const isProd = env === 'production'

  const currentHref = typeof window !== 'undefined' ? window.location.href : ''
  const deepLinkParam = isProd ? currentHref : currentHref.replace(/^https?:\/\//i, 'cashme://')
  const baseUrl = customUrl || (isProd ? APP_DOWNLOAD_WITH_DEEP_LINK_PRODUCTION : APP_DOWNLOAD_WITH_DEEP_LINK_STAGING)

  return `${baseUrl}?deep_link_value=${encodeURIComponent(deepLinkParam)}`
}

export const deeplinkToApp = () => {
  const currentUrl = typeof window !== 'undefined' ? new URL(window.location.href) : undefined
  if (currentUrl) {
    window.location.href = 'cashme://' + currentUrl?.hostname + currentUrl.pathname
  } else {
    // don't think this would happen, but since we're handling it, added a fallback URL
    window.location.href = 'cashme://cash.app/f/default'
  }
}
